import { createSlice } from "@reduxjs/toolkit";
import { recurringSummaryHistory as initialState } from "../initialState";

const getRecurringSummaryHistoryInitialState = () => initialState;

export const recurringSummaryHistoryInitialState =
    getRecurringSummaryHistoryInitialState();

export const slice = createSlice({
    name: "recurringSummaryHistory",
    initialState: recurringSummaryHistoryInitialState,
    reducers: {
        setRecurringSummaryHistory: (state, action) => action.payload,
    },
});

export const { setRecurringSummaryHistory } = slice.actions;

// selectors

export const selectRecurringSummaryHistory = (state) =>
    state?.recurringSummaryHistory || {};

export const selectHistoricalTotalImpact = (state) =>
    state?.recurringSummaryHistory?.historicalTotalImpact || 0;

export const selectRecurringTransactionHistory = (state) =>
    state?.recurringSummaryHistory?.transactionHistory || [];

export const selectHistoricalTotalCount = (state) =>
    state?.recurringSummaryHistory?.historicalTotalCount || 0;

export default slice.reducer;
